import React from 'react';
import { Container, Spinner, Row, Button, Col, Form } from 'react-bootstrap';
import MaterialTable from 'material-table';
import { PatchedPagination } from '../services/PatchedPagination.js';
import Modal from 'react-bootstrap/Modal';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';
import DeleteIcon from '@material-ui/icons/Delete';

const pageSizes = [5, 10, 25, 50, 100];

const searchBy = [
    { key: 'Slug Name', value: 'name' },
    { key: 'Master GC', value: 'master_gc' }
];

class AllGiftCards extends React.Component {
    _isMounted = false;
    state = {
        perPage: 5,
        pageNumber: 0,
        LastDocument: false,
        FirstDocument: false,
        StartAt: [],
        moveTo: false,
        search_key: '',
        search_by: 'name',
        
        modalShow: false,
        delmodalShow: false,
        GCmodalShow:false,
        alert: 0,
        alertMessage: '',
        data: [],
        selectedItem: [],
        flag: true,
        showAdd: false,
        title:'',
        Category:this.props.Category?this.props.Category.documentId:'',
        gc_key:'',
        gc_search_by:'name',
        gc_list:[],
        selected_gc:''
    };
    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
        this.loadData();
    }
    

    
    
    async loadData() {
        if (this._isMounted) {
            this.setState({showLoading: true });
        }
        let bodyData = {
            search_key: this.state.search_key,
            search_by: this.state.search_by,
            LastDocument: this.state.LastDocument,
            FirstDocument: this.state.FirstDocument,
            StartAt: await this.getStartAt(),
            perPage: parseInt(this.state.perPage),
            moveTo: this.state.moveTo,
            category:this.state.Category
        };
        
        await RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            bodyData,
            'slugs/all-slugs'
         )
            .then((response) => response.json())
            .then((responseData) => {
                
                if(responseData.error){
                    if (this._isMounted) {
                        this.setState({
                            flag: false,
                            showLoading: false,
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                }else{
                
                    if (this.state.moveTo === 'Prev') {
                        var newPageNumber = this.state.pageNumber - 1;
                        var filteredArray = this.state.StartAt.filter(
                            (item) => item !== responseData.FirstDocument
                        );
                        if (filteredArray.length < 2) {
                            var filteredArray = [];
                            filteredArray.push(responseData.FirstDocument);
                        }
                    } else if (this.state.moveTo === 'Next') {
                        var newPageNumber = this.state.pageNumber + 1;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    } else {
                        var newPageNumber = 0;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    }

                    if (this._isMounted) {
                        this.setState({
                            flag: false,
                            showLoading: false,
                            alert: 0,
                            alertMessage: '',
                            data:responseData.data,
                            pageNumber: newPageNumber,
                            StartAt: filteredArray,
                            LastDocument: responseData.LastDocument,
                            FirstDocument: responseData.FirstDocument,
                        });
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        showLoading: false,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }

    getStartAt = () => {
        let StartAtLIst = this.state.StartAt;

        if (StartAtLIst.length > this.state.pageNumber + 1) {
            StartAtLIst.splice(StartAtLIst.length - 2, StartAtLIst.length - 1);
            if (this._isMounted) {
                this.setState({ StartAt: StartAtLIst });
            }
        }
        return StartAtLIst[this.state.pageNumber - 1];
    };

    handlePageSizeChange = (event) => {
        if (this._isMounted) {
            this.setState({
                perPage: event.target.value,
                moveTo: false,
                StartAt: [],
                pageNumber: 0
            });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    submitSearch = () => {
        this.setState({ moveTo: false, StartAt: [], pageNumber: 0 });
        setTimeout(() => {
            this.loadData();
        }, 500);
    };

    restSearch = () => {
        this.setState({
            search_key: '',
            moveTo: false,
            StartAt: [],
            pageNumber: 0
        });
        setTimeout(() => {
            this.loadData();
        }, 500);
    };
    paginateNext = () => {
        
        if (this._isMounted) {
            this.setState({ flag: true, moveTo: 'Next' });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    paginatePrev = () => {
        if (this._isMounted) {
            this.setState({ flag: true, moveTo: 'Prev' });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };
    
    onChangeGCValues= (event) => {
            this.setState({gc_key:event.target.value})
    }
    onChangeGCBy= (event) => {
        this.setState({gc_search_by:event.target.value})
    }
    submitGCSearch= async () => {
        
        let bodyData = {
            search_key: this.state.gc_key,
            search_by: this.state.gc_search_by
        };
         
        await RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            bodyData,
            'slugs/all-slugs'
        )
            .then((response) => response.json())
            .then((responseData) => {
                
                if(responseData.data){
                this.setState({
                    gc_list: responseData.data
                });
                }
            })
    }

    onSelectGc = (event) => {
        this.setState({selected_gc:event.target.value})
    };

    UpdateGCConfirmed= async()=>{
        let bodyData={
            documentId:this.state.selected_gc,
            category:this.state.Category
        }
        
        await RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            bodyData,
            'slugs/update-slug-category'
        )
            .then((response) => response.json())
            .then((responseData) => {
                    this.loadData()
                    this.handleClose()
            })
    }

    restGCSearch= () => {
        this.setState({gc_key:''})
    }

    onChangeValues = (event) => {
        if (event.target.value === ''){
            this.setState({ [event.target.name]: '' });
        }else {
            this.setState({ [event.target.name]: event.target.value });
        }
        

    };
    handleClose = () => {
        if (this._isMounted) {
            this.setState({selectedItem:[],title:'',delmodalShow:false,GCmodalShow:false, modalShow: false});
        }
    };
    
    deleteDetail= (item)=>{
        if (this._isMounted) {
        this.setState({selectedItem:item, delmodalShow: true });
        }
    } 
    DeleteConfirmed= async()=>{
        let bodyData={
            documentId:this.state.selectedItem.documentId,
            category:''
        }
        
        await RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            bodyData,
            'slugs/update-slug-category'
        )
            .then((response) => response.json())
            .then((responseData) => {
                    this.loadData()
                    this.handleClose()
            })

    }
    

    
    render() {
        const options = {
            actionsColumnIndex: -1
        };

        const actions = [
            {
                icon: 'add',
                tooltip: 'Add new',
                position: 'toolbar',
                onClick: () => {
                    if (this._isMounted) {
                        this.setState({GCmodalShow: true, selectedItem: [] });
                    }
                }
            }
        ];

        
        return (
            <Container className="no_padding">
                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                {this.state.flag && <Spinner animation="border" />}
                {this.state.showLoading && <Spinner animation="border" />}

                            <div>
                                <hr />
                            </div>
                            
                            
                            <Row style={{ justifyContent: 'right' }}>
                                <Col
                                    style={{
                                        justifyContent: 'right',
                                        textAlign: 'right'
                                    }}
                                >
                                    <Form.Group
                                        as={Row}
                                        style={{
                                            justifyContent: 'right',
                                            marginRight: '0'
                                        }}
                                    >
                                        <select
                                            className="form-control"
                                            style={{ width: 'auto' }}
                                            name="search_by"
                                            onChange={this.onChangeValues}
                                            value={this.state.search_by}
                                        >
                                            {searchBy.map((search) => (
                                                <option
                                                    key={search.value}
                                                    value={search.value}
                                                >
                                                    Search By {search.key}
                                                </option>
                                            ))}
                                        </select>
                                        
                                    <Form.Control
                                        style={{
                                            marginLeft: '1rem',
                                            marginRight: '1rem',
                                            width: 'auto'
                                        }}
                                        placeholder="Search key"
                                        type="text"
                                        name="search_key"
                                        value={this.state.search_key}
                                        onChange={this.onChangeValues}
                                    />
                                        <Button
                                            variant="primary"
                                            onClick={this.submitSearch}
                                        >
                                            Search
                                        </Button>

                                        <Button
                                            style={{ marginLeft: '1rem' }}
                                            variant="primary"
                                            onClick={this.restSearch}
                                        >
                                            Reset
                                        </Button>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <MaterialTable
                                components={{
                                    Pagination: PatchedPagination
                                }}
                                title={"Gift Cards Slugs"}
                                columns={[
                                    {
                                        title: 'Name',
                                        field: 'name'
                                    },{
                                        title: 'Master Gift Card',
                                        field: 'master_gc',
                                        render: (row) => (
                                            <div>
                                                {row.master_gc}
                                            </div>
                                        )
                                    },
                                    {
                                        title: 'Slug',
                                        field: 'slug',
                                        render: (row) => (
                                            <div>
                                                {row.slug}
                                            </div>
                                        )
                                    },
                                    
                                    {
                                        title: 'Monthly Limit',
                                        field: 'monthly_limit',
                                        render: (row) => (
                                            <div>
                                                {row.monthly_limit}
                                            </div>
                                        )
                                    },
                                    { title: 'Action', field: '',
                                render: (row) => (
                                    <div>
                                        <DeleteIcon
                                            style={{ cursor: 'pointer', color: 'blue' }}
                                            onClick={(e) =>
                                                this.deleteDetail(row)
                                            }
                                        />

                                    
                                    </div>
                                ) },
                                    
                                ]}
                                data={this.state.data}
                                actions={actions}
                                options={{
                                    filtering: false,
                                    search: false,
                                    sorting: false,
                                    paging: false,
                                    actionsColumnIndex: -1
                                }}
                            />

                            <div>
                                <hr />
                            </div>
                            <Row className="custom_pagination">
                                {this.state.StartAt.length > 1 && (
                                    <Col>
                                        <Button
                                            onClick={this.paginatePrev}
                                            variant="primary"
                                        >
                                            Prev
                                        </Button>
                                    </Col>
                                )}
                                {this.state.StartAt.length < 2 && (
                                    <Col>
                                        <Button
                                            variant="secondary"
                                            disabled={true}
                                        >
                                            Prev
                                        </Button>
                                    </Col>
                                )}

                                <Col style={{ textAlign: 'center' }}>
                                    {'Items per page:'}
                                    <select
                                        className="items_per_page"
                                        onChange={this.handlePageSizeChange}
                                        value={this.state.perPage}
                                    >
                                        {pageSizes.map((size) => (
                                            <option key={size} value={size}>
                                                {size}
                                            </option>
                                        ))}
                                    </select>
                                    Page: {this.state.StartAt.length}
                                </Col>

                                <Col style={{ textAlign: 'right' }}>
                                    {this.state.data.length <
                                        this.state.perPage && (
                                        <Button
                                            variant="secondary"
                                            disabled={true}
                                        >
                                            Next
                                        </Button>
                                    )}

                                    {this.state.data.length >=
                                        this.state.perPage && (
                                        <Button
                                            onClick={this.paginateNext}
                                            variant="primary"
                                        >
                                            Next
                                        </Button>
                                    )}
                                </Col>
                            </Row>
                        
                
                <Modal  
                    show={this.state.GCmodalShow}
                    onHide={this.handleClose}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header closeButton>
                       <Modal.Title>Search Slug</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                    <Row style={{ justifyContent: 'right' }}>
                        <Col style={{ justifyContent: 'right', textAlign: 'right' }}>
                            <Form.Group as={Row}>
                            <select
                                className="form-control"
                                style={{ width: 'auto',marginLeft: '0.5rem'}}
                                name="gc_search_by"
                                value={this.state.gc_search_by}
                                onChange={this.onChangeGCBy}
                             >
                                
                                    <option key="search_by_brandName" value="name" >
                                    Name 
                                    </option>
                                    
                            </select>
                            
                                    <Form.Control
                                    style={{ width: 'auto',marginLeft: '0.5rem' }}
                                    placeholder="Gift Card Slug"
                                    type="text"
                                    name="gc_key"
                                    value={this.state.gc_key}
                                    onChange={this.onChangeGCValues}
                                />   
                                <Button style={{ marginLeft: '0.5rem' }} variant="primary" onClick={this.submitGCSearch} >
                                    Search
                                </Button>
                                <Button  style={{ marginLeft: '0.5rem' }} variant="primary" onClick={this.restGCSearch} >
                                Reset
                                </Button>
                            </Form.Group>
                        </Col>
                    </Row>
                    
                    {this.state.gc_list.length>0 &&<select
                        className="form-control"
                        style={{ width: '100%'}}
                        name="search_key"
                        onChange={this.onSelectGc}
                    >
                        <option key="gc_0" value="" >
                            Select
                        </option>
                        {this.state.gc_list.map((gc) => (
                            <option
                                key={gc.documentId}
                                value={gc.documentId}
                            >
                                {gc.name} ({gc.documentId})
                            </option>
                        ))}
                    </select>}
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Cancel
                        </Button>
                        {this.state.selected_gc &&<Button  variant="primary" onClick={this.UpdateGCConfirmed}>
                        Add to category
                        </Button>}
                        
                    </Modal.Footer>
                </Modal>

                <Modal  
                    show={this.state.delmodalShow}
                    onHide={this.handleClose}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Remove {this.state.selectedItem.name}</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                    <p>
                    Are you sure you want to remove this item from category?
                    </p>
                    
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={this.DeleteConfirmed}>
                           Delete
                        </Button>
                        
                    </Modal.Footer>
                </Modal>
                

            </Container>
        );
    }
}

export default AllGiftCards;
